import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import ContractDetailService from '../services/ContractDetailService';
import ContractDetail from './ContractDetail';
import { toJS } from 'mobx';

class ContractDetailContainer extends React.Component {
  static propTypes = {
    contractId: PropTypes.string,
    showOpenBills: PropTypes.bool,
  };

  static defaultProps = {
    showOpenBills: false,
  };

  contractDetailService = new ContractDetailService();
  componentDidMount() {
    if (this.props.contractId) {
      this.contractDetailService.load(this.props.contractId);
    }
  }

  render() {
    return (
      <ContractDetail
        values={toJS(this.contractDetailService.contract)}
        loading={this.contractDetailService.fetch.fetching}
        showOpenBills={this.props.showOpenBills}
      />
    );
  }
}

export default observer(ContractDetailContainer);
